import {mobileVhFix} from './utils/mobile-vh-fix.js';
import {initModals} from './modules/modals/init-modals';
// import {Form} from './modules/form-validate/form';
// import {CustomSelect} from './modules/select/custom-select';
// import {uploadFile, uploadImageDrop} from './modules/input-file/init-upload';
import {initBurgerAction} from './modules/init-burger-menu';

// ---------------------------------

window.addEventListener('DOMContentLoaded', () => {


  document.querySelectorAll('.stages__video').forEach(videoContainer => {
    const video = videoContainer.querySelector('video');

    videoContainer.addEventListener('click', function() {
        if (video.paused) {
            video.play(); // Запускаем видео
            videoContainer.classList.add('playing'); // Добавляем класс playing
        } else {
            video.pause(); // Ставим видео на паузу
            videoContainer.classList.remove('playing'); // Убираем класс playing
        }
    });
});

  document.querySelectorAll('.header__main-menu-link').forEach(link => {
    link.addEventListener('click', function(e) {
        e.preventDefault(); // Отменяем стандартное поведение ссылки

        const targetId = this.getAttribute('href'); // Получаем ID цели
        const targetElement = document.querySelector(targetId); // Находим элемент по ID

        if (targetElement) {
          const burgerBtn = document.querySelector('[data-mob-menu="menu-toggle"]');
          const burgerModElems = document.querySelectorAll('[data-mob-menu="burger-mod"]');
          const breakpointLg = window.matchMedia('(min-width:1150px)');
          
          
            burgerModElems.forEach((elem) => {
              elem.classList.remove('is-menu-open');
            });
            burgerBtn.ariaPressed = 'false';
            burgerBtn.classList.add('no-pointer');
            burgerBtn.classList.remove('is-menu-open');
            window.scrollLock.enableScrolling();
            setTimeout(() => {
              burgerBtn.classList.remove('no-pointer');
            }, 500);
            // Плавный скролл к элементу
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start' // Можно изменить на 'center' или 'end' в зависимости от ваших нужд
            });
        }
    });
});


  mobileVhFix();

  // Modules
  // ---------------------------------

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initModals();
    // uploadFile();
    // uploadImageDrop();
    initBurgerAction();
    // const select = new CustomSelect();
    // select.init();
    // const form = new Form();
    // window.form = form;
    // form.init();


    const gallery = document.querySelector('.invoice__galery');
    const rows = gallery.querySelectorAll('.invoice__galery__row');
    const items = gallery.querySelectorAll('.invoice__galery__item');
    function wrapItems() {
      let createdRows = gallery.querySelectorAll('.invoice__galery__row');
      createdRows.forEach(row => row.remove());
        rows.forEach(row => row.remove());

      if (window.innerWidth < 690) {
        for (let i = 0; i < items.length; i += 3) {
          const row = document.createElement('div');
          row.classList.add('invoice__galery__row');

          gallery.style.height =  'inherit';
          // Append up to 3 items to the row
          for (let j = 0; j < 3; j++) {
            if (items[i + j]) {
              row.appendChild(items[i + j]);
            }
          }
          gallery.appendChild(row);
          row.style.height =  'inherit';
          row.style.height = row.offsetHeight + 'px';

        }
      } else {
        // If width is greater than or equal to 690px, re-add items directly to gallery
        items.forEach(item => gallery.appendChild(item));
        let createdRows = gallery.querySelectorAll('.invoice__galery__row');
        createdRows.forEach(row => row.remove());
      }
  }

    function updateGalleryHeight() {

      if (window.innerWidth > 690) {
          let maxHeight = 0;
          gallery.style.height =  'inherit';
          gallery.style.height = gallery.offsetHeight + 'px';
          
      } else {

      }

    }

    wrapItems();
    updateGalleryHeight();

    // Обновляем высоту при изменении размера окна
    window.addEventListener('resize', wrapItems);
    window.addEventListener('resize', updateGalleryHeight);

    

    // Добавляем обработчик событий для элементов галереи
    items.forEach(item => {
      item.addEventListener('click', function() {
        // Удаляем класс _hover у всех элементов
        items.forEach(i => i.classList.remove('_hover'));
        
        // Добавляем класс _hover к текущему элементу
        this.classList.add('_hover');
        event.stopPropagation();

      });
    });
    document.addEventListener('click', function() {
      items.forEach(i => i.classList.remove('_hover'));
    });

  });
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
